var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTranslate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.113 7.553L4.623 9H3.376L5.47 3.375h1.444L9 9H7.687l-.49-1.447H5.114zm1.838-.828l-.763-2.274h-.056L5.37 6.724h1.583z",
    fill: "#7210FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.25A2.25 2.25 0 012.25 0h7.875a2.25 2.25 0 012.25 2.25v3.375h3.375A2.25 2.25 0 0118 7.875v7.875A2.25 2.25 0 0115.75 18H7.875a2.25 2.25 0 01-2.25-2.25v-3.375H2.25A2.25 2.25 0 010 10.125V2.25zm2.25-1.125A1.125 1.125 0 001.125 2.25v7.875A1.125 1.125 0 002.25 11.25h7.875a1.125 1.125 0 001.125-1.125V2.25a1.125 1.125 0 00-1.125-1.125H2.25zm8.03 11.244c.217.339.453.656.709.952-.841.647-1.882 1.126-3.114 1.454.2.244.507.714.624.975 1.266-.404 2.34-.95 3.247-1.68.874.747 1.957 1.31 3.296 1.655.15-.285.466-.757.708-1.001-1.266-.285-2.314-.78-3.172-1.444.766-.84 1.374-1.858 1.823-3.102h1.349V9h-3.375v1.178h.86c-.357.95-.832 1.74-1.43 2.396a6.809 6.809 0 01-.467-.553 2.237 2.237 0 01-1.058.348z",
    fill: "#7210FF"
  })));
}

export default SvgTranslate;